import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { BeatLoader } from 'global/Spinners';
import { setSnackBarObj } from '../../reducers/Alerts';
import { get } from 'lodash';

const ProgressAlerts = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const snackBarObj = useSelector(state => state.Alerts.snackBarObj);
  const beatLoader = useSelector(state => state.Alerts.beatLoader);
  let autoHideDuration, anchorOrigin, topMargin, severity, elevation, variant, message;

  if (snackBarObj) {
    autoHideDuration = get(snackBarObj, 'autoHideDuration', 5000);
    anchorOrigin = get(snackBarObj, 'anchorOrigin', { vertical: 'bottom', horizontal: 'left' });
    topMargin = get(snackBarObj, 'topMargin', null);
    severity = get(snackBarObj, 'severity', 'success');
    elevation = get(snackBarObj, 'elevation', 6);
    variant = get(snackBarObj, 'variant', 'filled');
    message = get(snackBarObj, 'message', 'Oops! Something unexpected happened.');
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setSnackBarObj(null));
  };

  return (
    <>
      {snackBarObj ? (
        <Snackbar
          open={true}
          autoHideDuration={autoHideDuration}
          onClose={handleClose}
          anchorOrigin={anchorOrigin}
          style={{ top: topMargin }}>
          <MuiAlert onClose={handleClose} severity={severity} elevation={elevation} variant={variant}>
            {message}
          </MuiAlert>
        </Snackbar>
      ) : null}

      {beatLoader > 0 ? (
        <div className={classes.loaderContainer}>
          <BeatLoader />
        </div>
      ) : null}
    </>
  );
};

export default ProgressAlerts;

const useStyles = makeStyles(theme => ({
  loaderContainer: {
    display: 'flex',
    width: 'auto',
    position: 'fixed',
    top: 70,
    left: '48%',
    zIndex: 10010,
    lineHeight: 0,
  },
}));
